export default {
  'pages.admin.ops.logViewer.previewTitle': 'Previsualización de log',
  'pages.admin.ops.logViewer.fileName': 'Nombre de archivo:',
  'pages.admin.ops.logViewer.lineCount': 'Número de líneas:',
  'pages.admin.ops.logViewer.previewBtn': 'Previsualizar',
  'pages.admin.ops.logViewer.noContent': 'No hay contenido disponible',  
  'pages.unbindDevice.cardTitle': 'Desvinculación de dispositivo',
  'pages.whiteList.cardTitle': 'Lista blanca de dispositivos',
  'pages.covenantDevice.mac': 'Dirección MAC',
  'pages.admin.providerCard.config.grpcAddr': 'Dirección gRPC',
  'pages.covenantDevice.cardTitle': 'Gestión de dispositivos contractuales',
  'pages.admin.whitelist.mac': 'Dirección MAC',
  'pages.covenantDevice.operations': 'Operaciones',
  'pages.covenantDevice.expireTime': 'Fecha de vencimiento',
  'pages.covenantDevice.updateTime': 'Hora de actualización',
  'pages.unbindDevice.titleAdmin': 'Desvincular dispositivo (requiere administrador)',
  'pages.unbindDevice.inputPlaceholder': 'Por favor, introduce el ID del dispositivo',
  'pages.unbindDevice.unbind': 'Desvincular',
  'pages.unbindDevice.unbinding': 'Desvinculando...',
  'pages.unbindDevice.success': 'Desvinculación exitosa',
  'pages.unbindDevice.fail': 'Error al desvincular',
  'pages.layouts.userLayout.title': 'Consola de gestión',
  'pages.login.accountLogin.tab': 'Inicio de sesión de cuenta',
  'pages.login.accountLogin.errorMessage':
    'Usuario/contraseña incorrectos (admin/ant.design)',
  'pages.login.failure': 'Inicio de sesión fallido, ¡inténtalo de nuevo!',
  'pages.login.success': '¡Inicio de sesión exitoso!',
  'pages.login.username.placeholder': 'Usuario: admin o user',
  'pages.login.username.required': '¡Por favor, introduce tu usuario!',
  'pages.login.password.placeholder': 'Contraseña: ant.design',
  'pages.login.password.required': '¡Por favor, introduce tu contraseña!',
  'pages.login.phoneLogin.tab': 'Inicio de sesión por teléfono',
  'pages.login.phoneLogin.errorMessage': 'Error de código de verificación',
  'pages.login.phoneNumber.placeholder': 'Número de teléfono',
  'pages.login.phoneNumber.required': '¡Por favor, introduce tu número de teléfono!',
  'pages.login.phoneNumber.invalid': '¡Número de teléfono no válido!',
  'pages.login.captcha.placeholder': 'Código de verificación',
  'pages.login.captcha.required': '¡Por favor, introduce el código de verificación!',
  'pages.login.phoneLogin.getVerificationCode': 'Obtener código',
  'pages.getCaptchaSecondText': 'seg',
  'pages.login.rememberMe': 'Recuérdame',
  'pages.login.forgotPassword': '¿Olvidaste la contraseña?',
  'pages.login.submit': 'Iniciar sesión',
  'pages.login.loginWith': 'Iniciar sesión con:',
  'pages.login.registerAccount': 'Registrar cuenta',
  'pages.welcome.link': 'Bienvenido',
  'pages.welcome.alertMessage':
    'Se han lanzado componentes de alto rendimiento, más rápidos y robustos.',
  'pages.404.subTitle': 'Lo sentimos, la página que visitaste no existe.',
  'pages.404.buttonText': 'Volver al inicio',
  'pages.admin.subPage.title': 'Esta página solo puede ser vista por administradores',
  'pages.admin.subPage.alertMessage':
    'Umi UI ha sido lanzado; bienvenido a usar npm run ui para iniciar la experiencia.',
  'pages.searchTable.createForm.newRule': 'Nueva regla',
  'pages.searchTable.updateForm.ruleConfig': 'Configuración de reglas',
  'pages.searchTable.updateForm.basicConfig': 'Información básica',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Nombre de la regla',
  'pages.searchTable.updateForm.ruleName.nameRules':
    '¡Por favor, introduce el nombre de la regla!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Descripción de la regla',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Por favor, introduce al menos cinco caracteres',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    '¡Por favor, introduce una descripción de al menos cinco caracteres!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configurar propiedades',
  'pages.searchTable.updateForm.object': 'Objeto de monitoreo',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Plantilla de regla',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Tipo de regla',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Establecer periodo de programación',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Hora de inicio',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    '¡Por favor, elige una hora de inicio!',
  'pages.searchTable.titleDesc': 'Descripción',
  'pages.searchTable.ruleName': 'El nombre de la regla es obligatorio',
  'pages.searchTable.titleCallNo': 'Número de llamadas al servicio',
  'pages.searchTable.titleStatus': 'Estado',
  'pages.searchTable.nameStatus.default': 'predeterminado',
  'pages.searchTable.nameStatus.running': 'en ejecución',
  'pages.searchTable.nameStatus.online': 'en línea',
  'pages.searchTable.nameStatus.abnormal': 'anormal',
  'pages.searchTable.titleUpdatedAt': 'Última programación',
  'pages.searchTable.exception': '¡Por favor, introduce el motivo de la excepción!',
  'pages.searchTable.titleOption': 'Opción',
  'pages.searchTable.config': 'Configuración',
  'pages.searchTable.subscribeAlert': 'Suscribirse a alertas',
  'pages.searchTable.title': 'Formulario de consulta',
  'pages.searchTable.new': 'Nuevo',
  'pages.searchTable.chosen': 'elegido',
  'pages.searchTable.item': 'elemento',
  'pages.searchTable.totalServiceCalls': 'Número total de llamadas al servicio',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'eliminación por lotes',
  'pages.searchTable.batchApproval': 'aprobación por lotes',
  
  // Agents page related text
  'pages.agents.search.placeholder': 'Buscar agentes',
  'pages.agents.create.button': 'Crear agente',
  'pages.agents.addDevice.button': 'Añadir dispositivo',
  'pages.agents.create.modal.title': 'Crear agente',
  'pages.agents.create.modal.nameLabel': 'Nombre del agente',
  'pages.agents.create.modal.placeholder': 'Por favor, introduce el nombre del agente',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': 'Modelo de voz',
  'pages.agents.card.languageModel': 'Modelo de lenguaje',
  'pages.agents.card.lastChat': 'Último chat',
  'pages.agents.card.conversationId': 'ID de conversación',
  'pages.agents.card.clearConversation': 'Borrar ID de conversación',
  'pages.agents.card.clearConversation.success': 'ID de conversación borrado',
  'pages.agents.card.clearConversation.error': 'No se pudo borrar el ID de conversación',
  'pages.agents.card.configRole': 'Configurar rol',
  'pages.agents.card.voiceRecognition': 'Reconocimiento de voz',
  'pages.agents.card.voiceRecognition.developing': 'Función en desarrollo, permanece atento',
  'pages.agents.card.historyDialog': 'Diálogo histórico',
  'pages.agents.card.manageDevice': 'Gestionar dispositivos',
  'pages.agents.card.addDevice': 'Añadir dispositivo',
  'pages.agents.loading': 'Cargando lista de agentes...',
  'pages.agents.reload': 'Recargar',
  'pages.agents.empty.title': 'No hay agentes disponibles',
  'pages.agents.empty.createFirst': 'Crea tu primer agente',
  'pages.agents.delete.title': 'Confirmar eliminación de agente',
  'pages.agents.delete.content': 'Tras eliminar el agente, no se podrán recuperar las configuraciones relacionadas (incluidos registros de conversación de dispositivos). ¿Seguro que deseas eliminarlo?',
  'pages.agents.delete.confirm': 'Confirmar eliminación',
  'pages.agents.fetch.error': 'No se pudo obtener la lista de agentes',
  'pages.agents.network.error': 'Error de red, inténtalo más tarde',
  'pages.agents.speed.patient': 'Paciente',
  'pages.agents.speed.normal': 'Normal',
  'pages.agents.speed.fast': 'Rápido',
  'pages.agents.lastChat.none': 'Ninguno',
  'pages.agents.language.chinese': 'Chino',
  'pages.agents.loading.tts.error': 'Error al cargar voces TTS',
  'pages.agents.loading.llm.error': 'Error al cargar proveedores LLM',
  'pages.agents.sort.id': 'Ordenar por ID',
  'pages.agents.sort.updatedAt': 'Ordenar por última modificación',
  'pages.agents.sort.lastConversationAt': 'Ordenar por última conversación',
  
  // Register page related text
  'pages.register': 'Registrarse',
  'pages.register.title': 'Registrarse',
  'pages.register.form.title': 'Registrar nueva cuenta',
  'pages.register.submit': 'Registrarse',
  'pages.register.username.placeholder': 'Por favor, introduce un nombre de usuario',
  'pages.register.username.required': '¡Por favor, introduce un nombre de usuario!',
  'pages.register.username.min': 'El nombre de usuario debe tener al menos 4 caracteres',
  'pages.register.email.placeholder': 'Por favor, introduce el correo electrónico',
  'pages.register.email.required': '¡Por favor, introduce el correo electrónico!',
  'pages.register.email.invalid': '¡Por favor, introduce un correo electrónico válido!',
  'pages.register.password.placeholder': 'Por favor, introduce la contraseña',
  'pages.register.password.required': '¡Por favor, introduce la contraseña!',
  'pages.register.password.min': 'La contraseña debe tener al menos 6 caracteres',
  'pages.register.password.pattern': 'La contraseña debe contener mayúsculas, minúsculas y números',
  'pages.register.confirmPassword.placeholder': 'Por favor, confirma la contraseña',
  'pages.register.confirmPassword.required': '¡Por favor, confirma la contraseña!',
  'pages.register.confirmPassword.min': 'La contraseña debe tener al menos 6 caracteres',
  'pages.register.error.passwordMismatch': 'Las dos contraseñas no coinciden',
  'pages.register.error.registerFailed': 'El registro falló, ¡inténtalo de nuevo!',
  'pages.register.success': '¡Registro exitoso!',
  
  // Login page related text
  'pages.login.title': 'Consola de gestión de Anime AI Chat',
  'pages.login.actionIcons.notImplemented': 'Aún no implementado, próximamente',
  'pages.login.mobile.captchaError': 'Error en el código de verificación',
  'pages.login.captcha.success': '¡Código de verificación enviado con éxito! Código: 1234',
  'pages.login.forgotPassword.contactAdmin': 'Por favor, contacta al administrador',
  'pages.login.mobile.notAvailable': 'Esta función aún no está disponible, usa el inicio de sesión con cuenta',
  
  // AgentSetting page related text
  'pages.agentSetting.title': 'Configurar rol',
  'pages.agentSetting.back': 'Volver',
  'pages.agentSetting.roleTemplate.title': 'Plantilla de rol',
  'pages.agentSetting.roleTemplate.label': 'Plantilla',
  'pages.agentSetting.template.taiwanGirlfriend': 'Novia taiwanesa',
  'pages.agentSetting.template.potato': 'Patata',
  'pages.agentSetting.template.englishTutor': 'Tutor de inglés',
  'pages.agentSetting.template.curiousBoy': 'Chico curioso',
  'pages.agentSetting.template.puppyLeader': 'Líder cachorro',
  'pages.agentSetting.basicConfig.title': 'Configuración básica',
  'pages.agentSetting.assistantName.label': 'Nombre del asistente',
  'pages.agentSetting.assistantName.placeholder': 'Por favor, introduce el nombre del asistente',
  'pages.agentSetting.assistantName.required': 'Por favor, introduce el nombre del asistente',
  'pages.agentSetting.dialogLanguage.label': 'Idioma del diálogo',
  'pages.agentSetting.dialogLanguage.placeholder': 'Selecciona idioma del diálogo',
  'pages.agentSetting.voiceType.label': 'Tipo de voz',
  'pages.agentSetting.voiceType.placeholder': 'Selecciona tipo de voz',
  'pages.agentSetting.roleDescription.title': 'Descripción del rol',
  'pages.agentSetting.roleDescription.label': 'Descripción del rol',
  'pages.agentSetting.roleDescription.placeholder': 'Por favor, introduce la descripción del rol',
  'pages.agentSetting.roleDescription.required': 'Por favor, introduce la descripción del rol',
  'pages.agentSetting.languageModel.title': 'Modelo de lenguaje',
  'pages.agentSetting.languageModel.label': 'Modelo de lenguaje',
  'pages.agentSetting.languageModel.placeholder': 'Selecciona el modelo de lenguaje',
  'pages.agentSetting.languageModel.tip': 'Tras cambiar el modelo, se recomienda limpiar la memoria para no afectar la experiencia de chat.',
  'pages.agentSetting.advancedSettings.expand': 'Expandir configuración avanzada',
  'pages.agentSetting.advancedSettings.collapse': 'Contraer configuración avanzada',
  'pages.agentSetting.recognitionSpeed.label': 'Velocidad de reconocimiento de voz',
  'pages.agentSetting.recognitionSpeed.placeholder': 'Selecciona la velocidad de reconocimiento',
  'pages.agentSetting.speechSpeed.label': 'Velocidad de habla',
  'pages.agentSetting.speechSpeed.placeholder': 'Selecciona la velocidad de habla',
  'pages.agentSetting.pitchValue.label': 'Volumen del personaje',
  'pages.agentSetting.button.reset': 'Restablecer',
  'pages.agentSetting.button.save': 'Guardar',
  'pages.agentSetting.save.success': 'Guardado exitoso',
  'pages.agentSetting.save.error': 'Error al guardar',
  'pages.agentSetting.save.missingId': 'Falta el ID del agente, no se puede guardar',
  'pages.agentSetting.load.tts.error': 'Error al cargar voces TTS',
  'pages.agentSetting.speed.slow': 'Lento',
  'pages.agentSetting.speed.normal': 'Normal',
  'pages.agentSetting.speed.fast': 'Rápido',
  'pages.agentSetting.speed.patient': 'Paciente',
  'pages.agentSetting.language.chinese': 'Chino',
  'pages.agentSetting.language.english': 'Inglés',
  'pages.agentSetting.language.spanish': 'Español',
  'pages.agentSetting.language.french': 'Francés',
  'pages.agentSetting.language.german': 'Alemán',
  'pages.agentSetting.language.japanese': 'Japonés',
  'pages.agentSetting.language.korean': 'Coreano',
  'pages.agentSetting.language.portuguese': 'Portugués',
  'pages.agentSetting.language.arabic': 'Árabe',
  'pages.agentSetting.language.russian': 'Ruso',
  'pages.agentSetting.language.italian': 'Italiano',
  'pages.agentSetting.language.turkish': 'Turco',
  'pages.agentSetting.language.polish': 'Polaco',
  'pages.agentSetting.language.catalan': 'Catalán',
  
  // DeviceManagement page related text
  'pages.devices.title': 'Gestionar dispositivos',
  'pages.devices.breadcrumb.agents': 'Agentes',
  'pages.devices.breadcrumb.devices': 'Gestionar dispositivos',
  'pages.devices.button.addDevice': 'Añadir dispositivo',
  'pages.devices.warning.noAgentId': 'Sin agentId especificado, no se puede obtener la lista de dispositivos',
  'pages.devices.device.unnamed': 'Dispositivo sin nombre',
  'pages.devices.device.macAddress': 'Dirección MAC',
  'pages.devices.device.lastActive': 'Última actividad',
  'pages.devices.device.firmwareVersion': 'Versión de firmware',
  'pages.devices.device.otaUpgrade': 'Actualización OTA',
  'pages.devices.device.noData': 'Sin datos',
  'pages.devices.copy.success': 'Dirección MAC copiada',
  'pages.devices.unbind.title': 'Confirmar desvinculación de dispositivo',
  'pages.devices.unbind.content': 'La desvinculación del dispositivo no se puede deshacer. Si necesitas usarlo de nuevo, tendrás que vincularlo otra vez. ¿Seguro que deseas desvincular?',
  'pages.devices.unbind.confirm': 'Confirmar desvinculación',
  'pages.devices.unbind.cancel': 'Cancelar',
  'pages.devices.unbind.success': 'Dispositivo desvinculado',
  'pages.devices.unbind.error': 'Error al desvincular',
  'pages.devices.ota.enabled': 'Actualización OTA habilitada',
  'pages.devices.ota.disabled': 'Actualización OTA deshabilitada',
  
  // HistoryDialogs page related text
  'pages.historyDialogs.title': 'Diálogos históricos',
  'pages.historyDialogs.breadcrumb.agents': 'Agentes',
  'pages.historyDialogs.breadcrumb.historyDialogs': 'Diálogos históricos',
  'pages.historyDialogs.empty.title': 'Ninguna conversación seleccionada',
  'pages.historyDialogs.empty.description': 'Por favor, selecciona una conversación',
  'pages.historyDialogs.agent': 'Agente',
  'pages.historyDialogs.agent.id': 'id',
  'pages.historyDialogs.conversationDetail': 'Detalles de la conversación',
  'pages.historyDialogs.selectConversation': 'Por favor, selecciona una conversación',
  'pages.historyDialogs.delete.title': 'Eliminar conversación',
  'pages.historyDialogs.delete.content': 'La conversación no se puede recuperar tras la eliminación. Por favor, confirma la operación.',
  'pages.historyDialogs.delete.confirm': 'Confirmar',
  'pages.historyDialogs.delete.cancel': 'Cancelar',
  'pages.historyDialogs.message.delete.confirm': '¿Seguro que deseas eliminar este mensaje? No se podrá recuperar tras eliminarlo.',
  'pages.historyDialogs.detail.title': 'Detalles de la conversación',
  'pages.historyDialogs.agent.label': 'Agente:',
  'pages.historyDialogs.user.label': 'Usuario:',
  'pages.historyDialogs.loading': 'Cargando...',
  'pages.historyDialogs.error.loadFailed': 'No se pudo cargar la lista de conversaciones',
  'pages.historyDialogs.error.deleteFailed': 'No se pudo eliminar la conversación',
  'pages.historyDialogs.success.deleteSuccess': 'Conversación eliminada correctamente',
  
  // MessageList page related text
  'pages.messageList.empty': 'Sin mensajes',
  'pages.messageList.user': 'Usuario',
  'pages.messageList.ai': 'IA',
  
  // Settings page related text
  'pages.settings.basicInfo.title': 'Información básica',
  'pages.settings.avatar.label': 'Avatar:',
  'pages.settings.avatar.change': 'Cambiar avatar',
  'pages.settings.avatar.updateSuccess': 'Avatar actualizado correctamente',
  'pages.settings.avatar.updateFailed': 'Error al actualizar el avatar',
  'pages.settings.username.label': 'Usuario:',
  'pages.settings.nickname.label': 'Apodo:',
  'pages.settings.nickname.change': 'Editar apodo',
  'pages.settings.nickname.modal.title': 'Editar apodo',
  'pages.settings.nickname.form.label': 'Nuevo apodo',
  'pages.settings.nickname.form.required': 'Por favor, introduce un nuevo apodo',
  'pages.settings.nickname.form.length': 'La longitud del apodo debe ser de 2-20 caracteres',
  'pages.settings.nickname.updateSuccess': 'Apodo actualizado correctamente',
  'pages.settings.nickname.updateFailed': 'Error al actualizar el apodo',
  'pages.settings.registerTime.label': 'Hora de registro:',
  'pages.settings.email.label': 'Correo electrónico:',
  'pages.settings.email.unbind': 'No vinculado',
  'pages.settings.email.bind': 'Vincular correo',
  'pages.settings.email.change': 'Cambiar correo',
  'pages.settings.email.modal.title': 'Vincular correo',
  'pages.settings.email.modal.changeTitle': 'Cambiar correo',
  'pages.settings.email.form.label': 'Correo electrónico',
  'pages.settings.email.form.required': 'Por favor, introduce el correo electrónico',
  'pages.settings.email.form.invalid': 'Formato de correo no válido',
  'pages.settings.email.bindSuccess': 'Correo vinculado correctamente',
  'pages.settings.email.bindFailed': 'Error al vincular el correo',
  'pages.settings.changePassword.title': 'Cambiar contraseña',
  'pages.settings.changePassword.button': 'Cambiar contraseña',
  'pages.settings.changePassword.modal.title': 'Cambiar contraseña',
  'pages.settings.changePassword.oldPassword.label': 'Contraseña antigua',
  'pages.settings.changePassword.oldPassword.required': 'Por favor, introduce la contraseña antigua',
  'pages.settings.changePassword.newPassword.label': 'Nueva contraseña',
  'pages.settings.changePassword.newPassword.required': 'Por favor, introduce la nueva contraseña',
  'pages.settings.changePassword.newPassword.min': 'La nueva contraseña debe tener al menos 6 caracteres',
  'pages.settings.changePassword.confirmPassword.label': 'Confirmar nueva contraseña',
  'pages.settings.changePassword.confirmPassword.required': 'Por favor, confirma la nueva contraseña',
  'pages.settings.changePassword.confirmPassword.mismatch': 'Las contraseñas no coinciden',
  'pages.settings.changePassword.success': 'Contraseña cambiada correctamente',
  'pages.settings.changePassword.failed': 'Error al cambiar la contraseña',
  'pages.settings.deleteAccount.title': 'Eliminar cuenta',
  'pages.settings.deleteAccount.button': 'Eliminar cuenta',
  'pages.settings.deleteAccount.confirm.title': '¿Confirmar eliminación de la cuenta?',
  'pages.settings.deleteAccount.confirm.content': 'Esta operación no se puede deshacer. ¿Seguro que deseas eliminar tu cuenta?',
  'pages.settings.deleteAccount.confirm.ok': 'Eliminar',
  'pages.settings.deleteAccount.confirm.cancel': 'Cancelar',
  'pages.settings.deleteAccount.success': 'Cuenta eliminada correctamente',
  'pages.settings.deleteAccount.failed': 'Error al eliminar la cuenta',
  'pages.settings.profile.fetchFailed': 'Error al obtener la información del usuario',
  'pages.settings.form.submit': 'Enviar',

  // Admin Dashboard
  'pages.admin.dashboard.userCount': 'Número de usuarios',
  'pages.admin.dashboard.deviceCount': 'Número de dispositivos', 
  'pages.admin.dashboard.agentCount': 'Número de agentes',
  'pages.admin.dashboard.onlineUsers': 'Usuarios en línea',
  'pages.admin.dashboard.sessionDevices': 'Dispositivos en sesión',
  'pages.admin.dashboard.memoryUsage': 'Uso de memoria',
  'pages.admin.dashboard.cpuUsage': 'Uso de CPU',
  'pages.admin.dashboard.fetchError': 'Error al obtener datos',
  'pages.admin.dashboard.networkError': 'Error de red',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': 'Usuario',
  'pages.admin.user.email': 'Correo electrónico',
  'pages.admin.user.status': 'Estado',
  'pages.admin.user.status.all': 'Todos',
  'pages.admin.user.status.disabled': 'Deshabilitado',
  'pages.admin.user.status.normal': 'Normal',
  'pages.admin.user.quotaUsed': 'Cuota diaria usada',
  'pages.admin.user.quotaTotal': 'Cuota diaria total',
  'pages.admin.user.createdAt': 'Creado el',
  'pages.admin.user.operations': 'Operaciones',
  'pages.admin.user.edit': 'Editar',
  'pages.admin.user.detail': 'Detalle',
  'pages.admin.user.editModal.title': 'Editar usuario',
  'pages.admin.user.status.label': 'Estado del usuario',
  'pages.admin.user.status.enable': 'Habilitar',
  'pages.admin.user.status.disable': 'Deshabilitar',
  'pages.admin.user.quotaUsed.label': 'Cuota diaria usada',
  'pages.admin.user.quotaTotal.label': 'Cuota diaria total',
  'pages.admin.user.email.label': 'Correo electrónico',
  'pages.admin.user.save.success': 'Guardado correctamente',
  'pages.admin.user.save.failed': 'Error al guardar',
  'pages.admin.user.list.title': 'Lista de usuarios',

  // Admin Model Providers
  'pages.admin.providers.title': 'Gestión de proveedores de modelos',
  'pages.admin.providers.total': 'Total {total} proveedores',
  'pages.admin.providers.stats': 'ASR: {asr}, TTS: {tts}, LLM: {llm}, VLLLM: {vlllm}',
  'pages.admin.providers.addNew': 'Agregar nuevo proveedor',
  'pages.admin.providers.search.placeholder': 'Buscar nombre del proveedor, endpoint o modelo...',
  'pages.admin.providers.filter.all': 'Todos los tipos',
  'pages.admin.providers.filter.asr': 'ASR - Reconocimiento de voz',
  'pages.admin.providers.filter.tts': 'TTS - Texto a voz', 
  'pages.admin.providers.filter.llm': 'LLM - Gran modelo de lenguaje',
  'pages.admin.providers.filter.vlllm': 'VLLLM - Modelo de lenguaje visual',
  'pages.admin.providers.empty.noProviders': 'Aún no hay proveedores',
  'pages.admin.providers.empty.noMatches': 'No se encontraron proveedores coincidentes',
  'pages.admin.providers.empty.addFirst': 'Haz clic en el botón de arriba para agregar tu primer proveedor de modelos',
  'pages.admin.providers.empty.adjustFilters': 'Intenta ajustar los criterios de búsqueda o filtros',
  'pages.admin.providers.type.asr': 'ASR - Reconocimiento de voz',
  'pages.admin.providers.type.tts': 'TTS - Texto a voz',
  'pages.admin.providers.type.llm': 'LLM - Gran modelo de lenguaje',
  'pages.admin.providers.type.vlllm': 'VLLLM - Modelo de lenguaje visual',
  'pages.admin.providers.success.created': '¡Proveedor agregado con éxito!',
  'pages.admin.providers.success.updated': '¡Proveedor actualizado con éxito!',
  'pages.admin.providers.success.deleted': '¡Proveedor eliminado con éxito!',
  'pages.admin.providers.success.statusToggled': '¡Estado cambiado con éxito!',
  'pages.admin.providers.error.createFailed': 'Error al agregar proveedor, inténtalo de nuevo',
  'pages.admin.providers.error.updateFailed': 'Error al actualizar proveedor, inténtalo de nuevo',
  'pages.admin.providers.error.deleteFailed': 'Error al eliminar proveedor, inténtalo de nuevo',
  'pages.admin.providers.error.testFailed': 'La prueba de conexión falló; revisa la red o la configuración',
  'pages.admin.providers.error.toggleFailed': 'No se pudo cambiar el estado; inténtalo de nuevo',
  'pages.admin.providers.error.loadFailed': 'Error al cargar la lista de proveedores; actualiza la página',

  // Admin Settings
  'pages.admin.settings.title': 'Configuración del sistema',
  'pages.admin.settings.asr.label': 'Servicio ASR',
  'pages.admin.settings.asr.placeholder': 'Selecciona servicio ASR',
  'pages.admin.settings.tts.label': 'Servicio TTS',
  'pages.admin.settings.tts.placeholder': 'Selecciona servicio TTS',
  'pages.admin.settings.llm.label': 'Servicio LLM',
  'pages.admin.settings.llm.placeholder': 'Selecciona servicio LLM',
  'pages.admin.settings.vlllm.label': 'Servicio VLLLM',
  'pages.admin.settings.vlllm.placeholder': 'Selecciona servicio VLLLM',
  'pages.admin.settings.prompt.label': 'Configuración de prompt',
  'pages.admin.settings.prompt.placeholder': 'Por favor, introduce el prompt del sistema...',
  'pages.admin.settings.quickReply.label': 'Respuestas rápidas',
  'pages.admin.settings.quickReply.placeholder': 'Introduce una nueva respuesta rápida',
  'pages.admin.settings.quickReply.add': 'Agregar',
  'pages.admin.settings.deleteAudio.label': 'Eliminar audio',
  'pages.admin.settings.deleteAudio.enabled': 'Habilitado',
  'pages.admin.settings.deleteAudio.disabled': 'Deshabilitado',
  'pages.admin.settings.usePrivateConfig': 'Usar configuración privada',
  'pages.admin.settings.save': 'Guardar configuración',
  'pages.admin.settings.saving': 'Guardando...',
  'pages.admin.settings.reset': 'Restablecer',
  'pages.admin.settings.success.saved': '¡Configuración guardada con éxito!',
  'pages.admin.settings.error.saveFailed': 'Error al guardar la configuración, inténtalo de nuevo',
  'pages.admin.settings.error.loadFailed': 'Error al cargar la configuración, actualiza la página e inténtalo de nuevo',

  // Add Device Dialog
  'pages.addDevice.modal.title': 'Añadir dispositivo',
  'pages.addDevice.verificationCode.label': 'Código de verificación:',
  'pages.addDevice.verificationCode.placeholder': 'Por favor, introduce el código de 6 dígitos del dispositivo',
  'pages.addDevice.verificationCode.required': 'Por favor, introduce un código de 6 dígitos',
  'pages.addDevice.verificationCode.error': 'Por favor, introduce un código de 6 dígitos',

  // Provider Modal
  'pages.admin.providerModal.edit.title': 'Editar proveedor',
  'pages.admin.providerModal.add.title': 'Agregar nuevo proveedor',
  'pages.admin.providerModal.name.label': 'Nombre del proveedor *',
  'pages.admin.providerModal.name.placeholder': 'p. ej.: OpenAI, Doubao TTS',
  'pages.admin.providerModal.name.required': 'Por favor, introduce el nombre del proveedor',
  'pages.admin.providerModal.type.label': 'Categoría del servicio *',
  'pages.admin.providerModal.subType.label': 'Tipo específico *',
  'pages.admin.providerModal.subType.required': 'Por favor, selecciona el tipo específico',
  'pages.admin.providerModal.config.title': 'Configuración',
  'pages.admin.providerModal.api.url.label': 'URL de la API *',
  'pages.admin.providerModal.api.url.required': 'Por favor, introduce la URL de la API',
  'pages.admin.providerModal.model.name.label': 'Nombre del modelo *',
  'pages.admin.providerModal.model.name.required': 'Por favor, introduce el nombre del modelo',
  'pages.admin.providerModal.api.key.label': 'Clave API *',
  'pages.admin.providerModal.api.key.required': 'Por favor, introduce la clave API',
  'pages.admin.providerModal.temperature.label': 'Temperatura (0-2)',
  'pages.admin.providerModal.temperature.error': 'La temperatura debe estar entre 0 y 2',
  'pages.admin.providerModal.maxTokens.label': 'Tokens máximos',
  'pages.admin.providerModal.maxTokens.error': 'Los tokens máximos deben estar entre 1 y 32768',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': 'ID de la app *',
  'pages.admin.providerModal.appid.required': 'Por favor, introduce el ID de la app',
  'pages.admin.providerModal.accessToken.label': 'Token de acceso *',
  'pages.admin.providerModal.accessToken.required': 'Por favor, introduce el token de acceso',
  'pages.admin.providerModal.cluster.label': 'Clúster',
  'pages.admin.providerModal.grpc.host.label': 'Host gRPC *',
  'pages.admin.providerModal.grpc.host.required': 'Por favor, introduce la dirección del host gRPC',
  'pages.admin.providerModal.grpc.port.label': 'Puerto gRPC *',
  'pages.admin.providerModal.grpc.port.required': 'Por favor, introduce el puerto gRPC',
  'pages.admin.providerModal.voice.label': 'Voz *',
  'pages.admin.providerModal.voice.required': 'Por favor, introduce el tipo de voz',
  'pages.admin.providerModal.token.label': 'Token *',
  'pages.admin.providerModal.token.required': 'Por favor, introduce el token',
  'pages.admin.providerModal.websocket.label': 'URL de WebSocket *',
  'pages.admin.providerModal.websocket.required': 'Por favor, introduce la URL de WebSocket',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'Clave API *',
  'pages.admin.providerModal.siliconflow.apiKey.required': 'Por favor, introduce la clave API',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'URL de la API',
  'pages.admin.providerModal.manage.voices': 'Gestionar voces',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTS no requiere configuración adicional',
  'pages.admin.providerModal.submit.error': 'Error al enviar, inténtalo de nuevo',

  // Provider Card
  'pages.admin.providerCard.status.active': 'Activo',
  'pages.admin.providerCard.status.inactive': 'Desconectado',
  'pages.admin.providerCard.status.error': 'Error',
  'pages.admin.providerCard.status.unknown': 'Desconocido',
  'pages.admin.providerCard.warning.readonly.test': 'Permiso de solo lectura, no se puede probar el proveedor',
  'pages.admin.providerCard.warning.readonly.delete': 'Permiso de solo lectura, no se puede eliminar el proveedor',
  'pages.admin.providerCard.warning.readonly.edit': 'Permiso de solo lectura, no se puede editar el proveedor',
  'pages.admin.providerCard.warning.readonly.toggle': 'Permiso de solo lectura, no se puede cambiar el estado',
  'pages.admin.providerCard.button.disable': 'Deshabilitar',
  'pages.admin.providerCard.button.enable': 'Habilitar',
  'pages.admin.providerCard.button.testing': 'Probando...',
  'pages.admin.providerCard.button.test': 'Probar',
  'pages.admin.providerCard.button.edit': 'Editar',
  'pages.admin.providerCard.button.delete': 'Eliminar',
  'pages.admin.providerCard.delete.title': '¿Seguro que deseas eliminar este elemento?',
  'pages.admin.providerCard.delete.content': 'No se puede recuperar después de eliminar, por favor confirma la operación.',
  'pages.admin.providerCard.config.type': 'Tipo',
  'pages.admin.providerCard.config.apiUrl': 'URL de la API',
  'pages.admin.providerCard.config.model': 'Modelo',
  'pages.admin.providerCard.config.apiKey': 'Clave API',
  'pages.admin.providerCard.config.temperature': 'Temperatura',
  'pages.admin.providerCard.config.maxTokens': 'Tokens máximos',
  'pages.admin.providerCard.config.appid': 'ID de la app',
  'pages.admin.providerCard.config.cluster': 'Clúster',
  'pages.admin.providerCard.config.accessToken': 'Token de acceso',
  'pages.admin.providerCard.config.grpcHost': 'Host gRPC',
  'pages.admin.providerCard.config.grpcPort': 'Puerto gRPC',
  'pages.admin.providerCard.config.voice': 'Voz',
  'pages.admin.providerCard.config.format': 'Formato',
  'pages.admin.providerCard.config.token': 'Token',
  'pages.admin.providerCard.config.outputDir': 'Directorio de salida',
  'pages.admin.providerCard.voices.supported': 'Voces compatibles',
  'pages.admin.providerCard.voices.count': '',
  'pages.admin.providerCard.test.failed': 'Prueba fallida',

  'pages.agentSetting.mcp.modal.title': 'Configuración del punto de conexión MCP',
  'pages.agentSetting.mcp.modal.statusLabel': 'Estado del punto de conexión',
  'pages.agentSetting.mcp.modal.online': 'En línea',
  'pages.agentSetting.mcp.modal.disconnected': 'Desconectado',
  'pages.agentSetting.mcp.modal.unknown': 'Desconocido',
  'pages.agentSetting.mcp.modal.refresh': 'Actualizar',
  'pages.agentSetting.mcp.modal.enabledServices': 'Servicios habilitados',
  'pages.agentSetting.mcp.modal.endpointLabel': 'Dirección del punto de conexión',
  'pages.agentSetting.mcp.modal.endpointDesc': 'A continuación se muestra la dirección del punto de conexión MCP del agente.',
  'pages.agentSetting.mcp.modal.docLink': 'Ver documentación del punto de conexión',
  'pages.agentSetting.mcp.modal.noEndpoint': 'No hay puntos de conexión disponibles',
  'pages.agentSetting.mcp.modal.hide': 'Ocultar',
  'pages.agentSetting.mcp.title': 'Configuración MCP', 
  'pages.agentSetting.mcp.customService': 'Servicio personalizado',
  'pages.agentSetting.mcp.officialServices': 'Servicios oficiales',
  'pages.agentSetting.mcp.officialServices.placeholder': 'Seleccionar servicios oficiales',
  'pages.agentSetting.mcp.services.weather': 'Clima',
  'pages.agentSetting.mcp.services.joke': 'Chiste',
  'pages.agentSetting.mcp.services.music': 'Música',
  'pages.agentSetting.mcp.services.news': 'Noticias',
  'pages.agentSetting.mcp.error.missingId': 'Falta el ID del agente, no se puede recuperar el punto de conexión',
  'pages.agentSetting.mcp.error.noEndpoint': 'No se pudo recuperar el punto de conexión del servidor',
'pages.agentSetting.mcp.error.fetchFailed': 'No se pudo recuperar el punto de conexión',
  'pages.agentSetting.mcp.button.getEndpoint': 'Obtener punto de conexión MCP',

  // Memory settings
  'pages.agentSetting.memory.title': 'Memoria a corto plazo',
  'pages.agentSetting.memory.type.label': 'Tipo de memoria',
  'pages.agentSetting.memory.type.none': 'Sin memoria',
  'pages.agentSetting.memory.type.shortTerm': 'Memoria a corto plazo',
  'pages.agentSetting.memory.current.label.short': 'Memoria actual',
  'pages.agentSetting.memory.current.help': 'Regenerada después de cada conversación',
  'pages.agentSetting.memory.clear': 'Borrar memoria',
  'pages.agentSetting.memory.clear.tip': 'Memoria marcada para borrar, haga clic en guardar para aplicar',
  'pages.agentSetting.memory.content.label': 'Contenido de la memoria',
  'pages.agentSetting.memory.content.placeholder': 'Obtener el contenido más reciente de la memoria a corto plazo del agente',
  'pages.agentSetting.memory.content.editPlaceholder': 'Por favor, ingrese el contenido de la memoria',
  'pages.agentSetting.memory.edit': 'Editar memoria',
  'pages.agentSetting.memory.edit.success': 'Memoria actualizada, por favor guarde para aplicar',
  'pages.agentSetting.memory.edit.save': 'Guardar cambios',
  'pages.agentSetting.memory.edit.cancel': 'Cancelar',

  // Botones y operaciones comunes
  'pages.common.cancel': 'Cancelar',

  // Configuración del sistema
  'pages.admin.systemConfig.roleName': 'Nombre del Rol',
  'pages.admin.systemConfig.roleDesc': 'Descripción del Rol',
  'pages.admin.systemConfig.enabled': 'Estado Activado',
  'pages.admin.systemConfig.featureName': 'Nombre de la Función',
  'pages.admin.systemConfig.featureDesc': 'Descripción de la Función',
  'pages.admin.systemConfig.exitCommand': 'Comando de Salida',
  'pages.admin.systemConfig.mcpName': 'Nombre MCP',
  'pages.admin.systemConfig.newNameOptional': 'Nuevo Nombre (Opcional)',
  'pages.admin.systemConfig.configJson': 'Config JSON',
  'pages.admin.systemConfig.useDeviceCode': 'Usar Código del Dispositivo',
  'pages.admin.systemConfig.quickReply': 'Respuesta Rápida',
  'pages.admin.systemConfig.shortTermMemory': 'Memoria a Corto Plazo',
  'pages.admin.systemConfig.saveUserAudio': 'Guardar Archivos de Audio del Usuario',
  'pages.admin.systemConfig.enableWhiteList': 'Habilitar Lista Blanca',
  'pages.admin.systemConfig.speakerDetect': 'Reconocimiento de Voz',
  'pages.admin.systemConfig.recorderManagerEnable': 'Habilitar Gestión de Grabadora',
  'pages.admin.systemConfig.voiceCloneEnable': 'Habilitar Clonación de Voz',
  'pages.admin.systemConfig.flattenedChatHistory': 'Historial de Chat Aplanado',
  'pages.admin.systemConfig.dialogueHistoryLength': 'Longitud del Historial de Diálogo',
  'pages.admin.systemConfig.userTotalQuota': 'Cuota Total del Usuario',
  'pages.admin.systemConfig.dailyClearQuota': 'Cuota Diaria',
  'pages.admin.systemConfig.checkDeviceModeImmediately': 'Verificar Modo del Dispositivo Inmediatamente',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': 'Rol de Observador Predeterminado para Nuevos Usuarios',
  'pages.admin.systemConfig.status': 'Estado',
  'pages.admin.systemConfig.port': 'Puerto',
  'pages.admin.systemConfig.udpShowPort': 'Mostrar Puerto',
  'pages.admin.systemConfig.accessToken': 'Token de Acceso',
  'pages.admin.systemConfig.activateText': 'Texto de Activación',
  'pages.admin.systemConfig.logLevel': 'Nivel de Registro',
  'pages.admin.systemConfig.logDir': 'Directorio de Registro',
  'pages.admin.systemConfig.logFileName': 'Nombre del Archivo de Registro',

  // Clonación de Voz
  'pages.console.voiceClone.name': 'Nombre',
  'pages.console.voiceClone.provider': 'Proveedor',
  'pages.console.voiceClone.mode': 'Modo',
  'pages.console.voiceClone.record': 'Grabar',
  'pages.console.voiceClone.upload': 'Subir',

  // Reconocimiento de Voz
  'pages.console.speakers.name': 'Nombre',
  'pages.console.speakers.mode': 'Modo',
  'pages.console.speakers.record': 'Grabar',
  'pages.console.speakers.upload': 'Subir',

  // Configuración de la Página
  'pages.console.settings.email': 'Email',
  'pages.console.settings.oldPassword': 'Contraseña Antigua',
  'pages.console.settings.newPassword': 'Nueva Contraseña',
  'pages.console.settings.confirmNewPassword': 'Confirmar Nueva Contraseña',

  // Proveedor VLLM
  'pages.providers.vllm.maxPixels': 'Máximo de Píxeles',
  'pages.admin.providerModal.copyAsNew': 'Copiar como Nuevo Proveedor',

  'pages.admin.devices': 'Administración de dispositivos',
  'pages.admin.unbindDevice': 'Desvincular dispositivo',
  'pages.admin.deviceManage': 'Administración de dispositivos',
  'pages.systemConfig.quickReply': 'Respuesta rápida',
  'pages.systemConfig.useShortTermMemory': 'Memoria a corto plazo',
  'pages.systemConfig.useShortTermMemory.desc': 'Cuando está activado, el sistema utiliza un mecanismo de memoria a corto plazo y la actualiza después de cada ronda de diálogo. Cuando está desactivado, no se utiliza la memoria a corto plazo.',
  'pages.agentSetting.mcp.modal.show': 'Mostrar',
  'pages.agentSetting.mcp.modal.copied': 'Copiado',
  'pages.agentSetting.mcp.modal.copy': 'Copiar',
  'pages.settings.password.title': 'Configuración de contraseña',
  'pages.settings.basicInfo.username': 'Nombre de usuario',
  'pages.settings.basicInfo.nickname': 'Apodo',
  'pages.settings.basicInfo.avatar': 'Avatar',
  'pages.settings.basicInfo.editNickname': 'Editar apodo',
  'pages.settings.basicInfo.editNicknameTitle': 'Modificar apodo',
  'pages.settings.basicInfo.newNicknameLabel': 'Nuevo apodo',
  'pages.settings.basicInfo.nicknameChangeSuccess': 'Cambio de apodo exitoso',
  'pages.settings.basicInfo.openId': 'OpenID:',
  'pages.settings.submit': 'Guardar',
  'pages.settings.deleteAccount.confirmTitle': 'Confirmar eliminación de cuenta',
  'pages.settings.deleteAccount.confirmContent': 'Tras eliminar la cuenta, todos sus datos se eliminarán permanentemente y no se podrán recuperar, y no podrá volver a iniciar sesión con esa cuenta. ¡Proceda con cautela!',
  'pages.settings.deleteAccount.cancel': 'Cancelar',
  'pages.settings.deleteAccount.confirm': 'Confirmar eliminación',
  'pages.admin.providerModal.model.label': 'Modelo *',
  'pages.admin.providerModal.model.placeholder': 'Ingrese el nombre del modelo',
  'pages.admin.providerModal.model.required': 'Ingrese el nombre del modelo',
  'pages.admin.providerModal.security.title': 'Configuración de seguridad',
  'pages.admin.providerModal.appid.placeholder': 'ID de aplicación Doubao',
  'pages.admin.providerModal.accessToken.placeholder': 'Token de acceso',
  'pages.admin.providerModal.grpc.addr.label': 'Dirección gRPC (Host:Puerto) *',
  'pages.admin.providerModal.grpc.addr.required': 'Ingrese la dirección gRPC (Host:Puerto)',
  'pages.admin.providerModal.token.placeholder': 'Token Doubao',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'Clave API',
  'pages.admin.providerModal.manageVoices': 'Administrar voces',
  'pages.admin.whiteList.inputMac': 'Ingrese la dirección MAC',
  'pages.admin.whiteList.batchAdd': 'Agregar por lotes',
  'pages.admin.whiteList.add': 'Agregar',
  'pages.admin.whiteList.list.title': 'Lista de direcciones MAC',
  'pages.admin.whiteList.selectCsvTip': 'Seleccione un archivo CSV',
  'pages.admin.whiteList.uploadSuccess': 'Carga exitosa',
  'pages.admin.whiteList.uploadFailed': 'Carga fallida',
  'pages.admin.whiteList.invalidMac': 'Ingrese una dirección MAC válida',
  'pages.admin.ops.service.title': 'Administración de servicios',
  'pages.admin.ops.upload.button': 'Cargar archivo de servicio',
  'pages.admin.ops.upload.success': 'Archivo de servicio cargado exitosamente',
  'pages.admin.ops.upload.error': 'Error al cargar el archivo de servicio',
  'pages.admin.ops.restart.button': 'Reiniciar servicio',
  'pages.admin.ops.restart.confirmTitle': 'Operación cuidadosa: ¿Confirmar reinicio del servicio?',
  'pages.admin.ops.restart.desc': 'Reiniciar el servicio provocará que todas las conexiones actuales se desconecten y el servicio estará temporalmente disponible.',
  'pages.admin.ops.restart.warn': 'Esta operación solo detendrá el proceso del servicio actual. Asegúrese de que el servidor tenga configurado un proceso daemon o un script de reinicio automático; de lo contrario, el servicio no se recuperará automáticamente.',
  'pages.admin.ops.restart.ok': 'Confirmar reinicio',
  'pages.admin.ops.restart.cancel': 'Cancelar',
  'pages.admin.ops.restart.success': 'Comando de reinicio de servicio enviado',
  'pages.admin.ops.restart.error': 'Error al reiniciar el servicio',
  'pages.admin.ops.log.title': 'Explorar y descargar registros',
  'pages.admin.ops.web.upload.button': 'Cargar web.zip',
  'pages.admin.ops.web.upload.success': 'web.zip cargado exitosamente',
  'pages.admin.ops.web.upload.error': 'Error al cargar web.zip',
  'pages.admin.ops.web.upload.onlyzip': 'Solo se permiten archivos ZIP',
  'pages.admin.ops.web.update.button': 'Actualizar directorio web',
  'pages.admin.ops.web.update.success': 'Comando de actualización del directorio web enviado',
  'pages.admin.ops.web.update.error': 'Error al actualizar el directorio web',
  'pages.admin.ops.web.upload.onlywebzip': 'Solo se permite cargar un archivo llamado web.zip',
  'pages.admin.recorder.title': 'Administración de grabaciones de dispositivos',
  'pages.admin.settings.voiceCloneEnable': 'Habilitar clonación de voz',
  'pages.admin.recorder.inputDeviceId': 'Ingrese el ID del dispositivo',
  'pages.admin.recorder.inputPlaceholder': 'Ingrese el ID del dispositivo',
  'pages.admin.recorder.search': 'Buscar',
  'pages.admin.recorder.list.title': 'Lista de grabaciones',
  'pages.admin.recorder.fetchSuccess': 'Grabaciones obtenidas exitosamente',
  'pages.admin.recorder.fetchError': 'Error al obtener la lista de grabaciones',
  'pages.admin.recorder.empty': 'Sin datos de grabación. Ingrese el ID del dispositivo para buscar',
  'pages.admin.recorder.totalCount': 'Estadísticas',
  'pages.admin.recorder.conversationId': 'ID de conversación',
  'pages.agentSetting.roleTemplate.empty': 'Sin plantillas disponibles. Verifique role_template.json',
  'pages.admin.providerModal.save': 'Guardar',
  'pages.contractDevice.cardTitle': 'Gestión de dispositivos contractuales',
  'pages.contractDevice.mac': 'Dirección MAC',
  'pages.contractDevice.protocolType': 'Tipo de protocolo',
  'pages.contractDevice.status': 'Estado',
  'pages.contractDevice.expireTime': 'Fecha de vencimiento',
  'pages.contractDevice.updateTime': 'Hora de actualización',
  'pages.contractDevice.operations': 'Operaciones',
  'pages.contractDevice.edit': 'Editar',
  'pages.contractDevice.delete': 'Eliminar',
  'pages.contractDevice.deleteConfirm': 'Confirmar eliminación',
  'pages.contractDevice.addTitle': 'Agregar dispositivo contractual',
  'pages.contractDevice.batchAddTitle': 'Agregar por lotes',
  'pages.contractDevice.editTitle': 'Editar dispositivo contractual',
  'pages.contractDevice.listTitle': 'Lista de dispositivos contractuales',
  'pages.contractDevice.add': 'Agregar',
  'pages.contractDevice.batchAdd': 'Agregar por lotes',
  'pages.contractDevice.selectCsvTip': 'Seleccione un archivo CSV',
  'pages.contractDevice.uploadSuccess': 'Carga exitosa',
  'pages.contractDevice.macRequired': 'Ingrese la dirección MAC',
  'pages.contractDevice.protocolTypeRequired': 'Seleccione el tipo de protocolo',
  'pages.contractDevice.statusRequired': 'Seleccione el estado',
  'pages.contractDevice.expireTimeRequired': 'Seleccione la fecha de vencimiento',
};